import type { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  padded?: boolean;
}

/** Surface blanche sur le fond gris clair de la page, avec une ombre douce. */
export default function Card({ children, className = "", padded = true }: CardProps) {
  return (
    <div
      className={`rounded-lg border border-background-200 bg-background-50 shadow-card ${padded ? "p-4 sm:p-5" : ""} ${className}`}
    >
      {children}
    </div>
  );
}

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export function SectionTitle({ title, subtitle, icon, action }: SectionTitleProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex min-w-0 items-start gap-3">
        {icon && (
          <span className="w-9 h-9 rounded-md bg-primary-50 text-primary-700 flex items-center justify-center shrink-0" aria-hidden="true">
            <i className={`${icon} text-lg`}></i>
          </span>
        )}
        <div className="min-w-0">
          <h3 className="text-base font-semibold text-foreground-950 font-heading">{title}</h3>
          {subtitle && <p className="text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}
